import { IoChevronBack } from "react-icons/io5";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import { useAppDispatch } from "../../../utils/hooks";
import StarMessageList from "./StarMessageList";
import { useLocation, useNavigate } from "react-router-dom";
import TextTranslate from "../../../utils/TextTranslate";

export default function StarMessage() {
  const dispatch = useAppDispatch();
  const locations = useLocation();
  const navigate = useNavigate();

  function handleBack() {
    if (locations.pathname == "/star-messages") {
      navigate(-1);
    } else {
      dispatch(updateViewState({ showStarMessageList: false }));
    }
  }

  const isStandalonePage = locations.pathname == "/star-messages";

  return (
    <div
      className={`flex min-h-0 w-full flex-col overflow-hidden bg-secondary ${
        isStandalonePage
          ? "h-[100dvh] max-w-md pb-[calc(3.25rem+env(safe-area-inset-bottom))] shadow-inner lg:pb-0"
          : "h-full"
      }`}
    >
      <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
        <div className="flex items-center justify-between px-3 py-3">
          <button
            type="button"
            aria-label="Back"
            className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
            onClick={handleBack}
          >
            <IoChevronBack className="text-xl" />
          </button>
          <span className="text-[17px] font-semibold tracking-tight text-darkText">
            <TextTranslate text="Starred Messages" />
          </span>
          <div className="h-9 w-9" aria-hidden />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-hidden">
        <StarMessageList />
      </div>
    </div>
  );
}
